var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecursion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9649 10.9645C13.1414 8.78065 13.1414 5.22301 10.9649 3.03915L9.80387 4.20014V0.702226H13.3019L11.9505 2.05361C14.6832 4.78251 14.6832 9.22116 11.9505 11.9538C10.2257 13.6747 7.82527 14.3131 5.60028 13.8577V12.4167C7.45568 12.8983 9.51268 12.4167 10.9649 10.9645Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.05 2.05361C3.77474 0.325183 6.17519 -0.313177 8.40019 0.142261V1.58324C6.54478 1.10167 4.48405 1.5907 3.03557 3.03915C0.851639 5.22301 0.851639 8.78065 3.03557 10.9645L4.19659 9.80352V13.3052H0.694844L2.04627 11.9538C-0.68271 9.22116 -0.682711 4.78251 2.05 2.05361Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecursion);
export default __webpack_public_path__ + "static/media/Recursion.17a78ffb91109ed9dbc579ee0d025af4.svg";
export { ForwardRef as ReactComponent };